// react, react-redux, react-dropzone, react-widgets
import React from "react";
import { connect } from "react-redux";
import Dropzone from 'react-dropzone';
import Multiselect from "react-widgets/lib/Multiselect";

// helpers
import { formatBytes } from "../../helpers/renderHelpers";

// Redux actions
import { uploadFile, deleteFile } from "../../actions/formActions";

// styling
import "react-widgets/dist/css/react-widgets.css";

class RenderField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rejectedFiles: [],
      dropZoneDisabled: false
    };
  }

  render() {
    const {
      input,
      note,
      label,
      width,
      required,
      min,
      max,
      category,
      maxlength,
      subCategory,
      disabled,
      type,
      dropUp,
      onSelect,
      meta: { asyncValidating, touched, active, error },
      data,
      disabledData,
      valueField,
      textField,
      placeholder,
      multiple = false,
      showLabel,
      uncheckable
    } = this.props;

    return (
      <div
        className={`sq-form-question sq-form-question-${type} ${
          active || touched ? "sq-form-question--focus" : ""
        } ${width ? width : ""}`}
      >
        {type === "checkbox" || type === "radiobox" ? (
          <legend className="sq-form-question-title">{label}
          {label && required && (
            <span className="sq-form-question-title-requiredAsterisk" />
          )}</legend>
        ) : (
          (showLabel || (!multiple && this.props.attachments.filter(file => file.id === input.name && (file.isUploading || file.transactionID)).length === 0) || multiple) && (
            <label className={`sq-form-question-title ${(required || required === false) ? 'sq-form-question-title-requiredAsterisk' : ''} ${this.state.rejectedFiles.length > 0 ? 'sq-form-error' : ''}`} htmlFor={input.name}>
              {label}
            </label>
          )
        )}
        {note && ((!multiple && this.props.attachments.filter(file => file.id === input.name && (file.isUploading || file.transactionID)).length === 0) || multiple)&& <div className="sq-form-question-note">{note}</div>}
        <div className={`sq-form-question-answer ${asyncValidating ? 'async-validating' : ''}`}>
          {type === "text" && (
            <input
              {...input}
              id={input.name}
              required={required}
              type={type}
              maxLength={maxlength}
              placeholder={placeholder}
              className="sq-form-field"
              onFocus={() => {
                input.onFocus();
              }}
              disabled={disabled || asyncValidating}
            />
          )}
          {type === "number" && (
            <input
              {...input}
              id={input.name}
              required={required}
              type={type}
              min={min}
              max={max}
              className="sq-form-field"
              onFocus={() => {
                input.onFocus();
              }}
              disabled={disabled || asyncValidating}
            />
          )}
          {type === "textarea" && (
            <textarea
              {...input}
              id={input.name}
              required={required}
              className="sq-form-field"
              maxLength={maxlength}
              cols="70"
              rows="7"
              onFocus={() => {
                input.onFocus();
              }}
            />
          )}
          {type === "select" && (
            <select {...input} className="sq-form-field" required={required}>
              {this.props.templateList &&
                this.props.templateList.map(option => (
                  <option
                    value={option.value}
                    key={option.value}
                    name={option.value}
                  >
                    {option.name}
                  </option>
                ))}
            </select>
          )}
          {type === "selectMultiple" && (
            <Multiselect
              {...input}
              onSelect={onSelect}
              onBlur={() => input.onBlur()}
              value={input.value || []} // requires value to be an array
              data={data}
              dropUp={dropUp}
              valueField={valueField}
              textField={textField}
              required={required}
              placeholder={placeholder}
              disabled={disabledData}
            />
          )}
          {type === "checkbox" && (
            <ul>
              {this.props.templateList &&
                this.props.templateList.map((option, index) => {
                  const checked = Array.isArray(input.value) ? input.value.includes(option.value) : input.value;

                  return (
                    <li key={index}>
                      <input
                        type="checkbox"
                        className="sq-form-field"
                        value={option.value}
                        checked={checked}
                        id={`${input.name}-${option.value}`}
                        name={`${input.name}[${index}]`}
                        onFocus={() => {
                          input.onFocus();
                        }}
                        onChange={event => {
                          const newValue = Object.values({...input.value});
                          if (event.target.checked) {
                            newValue.push(option.value);
                          } else {
                            newValue.splice(newValue.indexOf(option.value), 1);
                          }

                          return input.onChange(newValue);
                        }}
                      />
                      <label htmlFor={`${input.name}-${option.value}`}>
                        {option.name}
                      </label>
                    </li>
                  );
                })}
            </ul>
          )}
          {type === "radiobox" && (
            <ul>
              {this.props.templateList &&
                this.props.templateList.map((option, index) => {
                  const checked = input.value.includes(option.value);
                  return (
                    <li key={index}>
                      <input
                        {...input}
                        type="radio"
                        className="sq-form-field"
                        value={option.value}
                        checked={checked}
                        key={`${input.name}[${index}]`}
                        id={`${input.name}-${option.value}`}
                        name={input.name}
                        required={required}
                        onClick={event => {
                          if (uncheckable && checked) {
                            return input.onChange("");
                          }
                        }}
                        onBlur={event => {}}
                      />
                      <label htmlFor={`${input.name}-${option.value}`}>
                        {option.name}
                      </label>
                    </li>
                  );
                })}
            </ul>
          )}


          {type === "file" && (
            <div>
              {(multiple || (!multiple && this.props.attachments.filter(file => file.id === input.name && (file.isUploading || file.transactionID)).length === 0)) && (
                <Dropzone multiple={multiple} disabled={this.state.dropZoneDisabled} maxSize={4e+7} onDrop={ (acceptedFiles, rejectedFiles) => {
                  // set rejected files in the state
                  this.setState({rejectedFiles});

                  if (this.props.input) {
                    const {uploadFile} = this.props
                    
                    // disable the field if it's not multiple
                    if (!multiple && this.props.attachments.filter(file => file.id === input.name && file.transactionID).length !== 0) {
                      this.setState({dropZoneDisabled: true});
                    }

                    var attachmentURL = process.env.REACT_APP_PLANNING_API_URL + "/form-templates/attachments/";

                    acceptedFiles.forEach(file => {
                      return uploadFile(input.name, file, category, subCategory, attachmentURL)
                    });
                  }
                }
              } {...this.props} >
                  {({getRootProps, getInputProps,isDragActive}) => (
                    <section className="drop" style={{backgroundColor: (isDragActive && "#e0ebe0"), border: (isDragActive && "1px dashed #b4e4b4")}}>
                      <div className="drop-zone" {...getRootProps()}>
                        <input id={input.name} className="sq-form-field" {...getInputProps()}/>
                        {isDragActive && (<p className="dropContent">Drop {multiple ? 'files' : 'file'} here</p>)}
                        {!isDragActive && (<p className="dropContent"><span>Choose {multiple ? 'files' : 'a file'}</span> or drag {multiple ? 'files here' : 'a file here'}</p>)}
                      </div>
                    </section>
                  )}
                </Dropzone>
              )}
              {this.props.attachments.length > 0 && (
                <ul className="list list-uploadFile">
                  {this.props.attachments.filter(file => file.id === input.name).map((file, i) =>
                      <li key={i} label={file.id} className={`list-tile ${file.isUploading ? 'uploading' : ''}${file.transactionID ? 'approved' : ''}${file.error ? 'error' : ''}`}>
                        <div className="list-tile-content">
                          <div className="list-tile-content-name">
                            <p>
                              {file.isUploading && (<span>Uploading... </span>)}
                              {file.transactionID && (<span style={{display: 'block'}}>Uploaded: </span>)}
                              {file.error && (<span style={{display: 'block'}}>Not Uploaded: </span>)}
                              {file.originalFileName} ({formatBytes(file.fileSize, 2)})
                            </p>
                          </div>
                          {file.isUploading && (
                            <div className="list-tile-progress" style={{ backgroundImage: `linear-gradient(to right,#00b7bd ${file.percentage}%,#d5d5d5 ${file.percentage}%)`}} />
                          )}
                        </div>
                        {file.error && (
                          <p className="sq-form-error">{file.error}</p>
                        )}                  
                        {file.transactionID && (<button type="button" onClick={() => {this.setState({dropZoneDisabled: false}); this.props.deleteFile(file.transactionID)}} className="list-tile-button"></button>)}
                      </li>
                    )
                  }
                </ul>
              )}
              {this.state.rejectedFiles.length > 0 && (
                <ul className="list list-uploadFile">
                  {this.state.rejectedFiles && this.state.rejectedFiles.map((i) =>
                      <li key={i} className='list-tile error'>
                        <div className="list-tile-content">
                          <div className="list-tile-content-name">
                            <p><span>Not Uploaded: </span>{i.name} ({formatBytes(i.size, 2)})</p>
                          </div>
                        </div>
                        <p className="sq-form-error">Exceeds maximum upload size of 40MB</p>
                      </li>
                    )
                  }
                </ul>
              )}
            </div>
          )}
        </div>

        {touched && error && <p className="sq-form-error">{error}</p>}
      </div>
    );
  }
}



const mapDispatchToProps = {
  uploadFile,
  deleteFile
};

const mapStateToProps = state => {
  return {
    attachments: state.service.attachments,
    form: state.form
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RenderField);
